import "./index.scss"

const Separator = () => {
  return <div className="default-modal-separator"></div>
}

export default Separator
